/* eslint-disable react/no-array-index-key */
import React from 'react';
import axios from 'axios';

import getTeamsUrl from '../../../utils/getTeamsUrl';
import { Input } from '@/components/ui/input';
import { Loader2, Search } from 'lucide-react';
import { useEffect } from 'react';
import { isMobileViewport, useIsMobile } from '@/hooks/use-mobile';

const TeamSearch = ({
	assignedTypeSelected,
	isSearching,
	setIsSearching,
	setSearchResults,
	searchText,
	setSearchText,
}) => {
	const textSearchFieldRef = React.useRef(null);
	const isMobile = useIsMobile();

	const searchForMessages = async (searchTextFromInput) => {
		try {
			setIsSearching(true);
			setSearchResults([]);

			const res = await axios.post(
				`${getTeamsUrl(window.location.href)}/api/message-search`,
				{
					// The Enter listener is registered once, so prefer the
					// field's live value over this render's searchText.
					searchText: searchTextFromInput || searchText,
					isSearchingDirectMessages:
						assignedTypeSelected === 'DIRECT_MESSAGES',
				}
			);

			setIsSearching(false);

			if (res.data) {
				setSearchResults(res.data.results);
			}
		} catch (err) {
			console.log(err);
		}
	};

	useEffect(() => {
		const handleKeyDown = (e) => {
			if (e.key === 'Enter') {
				searchForMessages(textSearchFieldRef.current.value);
				// Phones: put the keyboard away so the results have the screen.
				if (isMobileViewport()) {
					textSearchFieldRef.current.blur();
				}
			}
		};

		const inputField = textSearchFieldRef.current;

		if (inputField) {
			inputField.addEventListener('keydown', handleKeyDown);

			return () => {
				inputField.removeEventListener('keydown', handleKeyDown);
			};
		}
	}, []);

	return (
		<div className="relative flex w-full items-center rounded-lg border border-border/60 bg-stone-100/70 transition-colors focus-within:border-foreground/30 focus-within:bg-background dark:bg-stone-900/60 max-md:rounded-[10px] max-md:border-0 max-md:bg-zinc-200/60 max-md:focus-within:bg-zinc-200/60 dark:max-md:bg-zinc-800 dark:max-md:focus-within:bg-zinc-800">
			<div className="pointer-events-none absolute left-2.5 flex items-center">
				{!isSearching ? (
					<Search className="size-4 text-muted-foreground" />
				) : (
					<Loader2 className="size-4 animate-spin text-primary" />
				)}
			</div>
			<Input
				// Phones get the search keyboard and its clear button.
				type={isMobile ? 'search' : undefined}
				enterKeyHint="search"
				autoComplete="off"
				autoCorrect="off"
				placeholder={
					assignedTypeSelected === 'DIRECT_MESSAGES'
						? 'Search direct messages'
						: 'Search groups'
				}
				aria-label={
					assignedTypeSelected === 'DIRECT_MESSAGES'
						? 'Search direct messages'
						: 'Search groups'
				}
				value={searchText}
				onChange={(e) => setSearchText(e.target.value)}
				className="h-9 w-full rounded-lg border-0 bg-transparent pl-8 pr-2 text-sm shadow-none focus-visible:ring-0 focus-visible:ring-offset-0 max-md:h-10"
				ref={textSearchFieldRef}
			/>
		</div>
	);
};

export default TeamSearch;
